import React from 'react'
import Summary from "./Summary.js";
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'

import Search from './Search';
import Status from './Status';
import Results from './Results';
import Whoops from './Whoops';
import OrderNotFound from './OrderNotFound';
import OrderRestriction from './OrderRestriction';
import EmailTemplateTest from './EmailTemplateTest';
import Edit from './Edit';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';


const theme = createMuiTheme({
    slimButton: {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif", fontWeight: 500,
        fontSize: "0.775rem",
        lineHeight: 1.75,
        letterSpacing: "0.02857em",
        textTransform: "none"
    },
    searchInput: {
        border: 0,
        background: "none"
    },
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#1177E9',
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            light: '#0066ff',
            main: '#0044ff',
            // dark: will be calculated from palette.secondary.main,
            contrastText: '#ffcc00',
        },
        // error: will use the default color
    },
    typography: {
        htmlFontSize: 7.5,
        fontSize: 12,
        fontFamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,

    },
    h1: {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 300,
        fontSize: "6rem",
        lineHeight: 1,
        letterSpacing: "-0.01562em"
    },
    h2: {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif", fontWeight: 300,
        fontSize: "3.75rem",
        lineHeight: 1,
        letterSpacing: "-0.00833em"
    },
    h3:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400,
        fontSize: "3rem",
        lineHeight: 1.04,
        letterSpacing: "0em"
    },
    h4:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400,
        fontSize: "2.125rem",
        lineHeight: 1.17,
        letterSpacing: "0.00735em"
    },
    h5: {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400, fontSize: "1.5rem",
        lineHeight: 1.33, letterSpacing: "0em"
    },
    h6:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 500,
        fontSize: "1.25rem",
        lineHeight: 1.6,
        letterSpacing: "0.0075em"
    },
    subtitle1:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.75,
        letterSpacing: "0.00938em"
    },
    subtitle2:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 500,
        fontSize: "0.875rem",
        lineHeight: 1.57,
        letterSpacing: "0.00714em"
    },
    body1:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5,
        letterSpacing: "0.00938em"
    },
    body2:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400,
        fontSize: "0.875rem",
        lineHeight: 1.43,
        letterSpacing: "0.01071em"
    },
    button:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif", fontWeight: 500,
        fontSize: "0.875rem",
        lineHeight: 1.75,
        letterSpacing: "0.02857em",
        textTransform: "none"
    },
    caption:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif", fontWeight: 400,
        fontSize: "0.75rem",
        lineHeight: 1.66,
        letterSpacing: "0.03333em"
    },
    overline:
    {
        fontfamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontWeight: 400,
        fontSize: "0.75rem",
        lineHeight: 2.66,
        letterSpacing: "0.08333em",
        textTransform: "uppercase"
    },
});




export default (props) => {

    return (
        <ThemeProvider theme={responsiveFontSizes(theme)}  >

            <Switch>
                <Route path={`${props.basePath}/`} exact render={() => <Search {...props} />} />
                <Route path={`${props.basePath}/Status`} render={() => <Status {...props} />} />
                <Route path={`${props.basePath}/Summary`} render={() => <Summary {...props} />} />
                <Route path={`${props.basePath}/Results`} component={Results} />
                <Route path={`${props.basePath}/Edit`} render={() => <Edit {...props} />} />
                <Route path={`${props.basePath}/Whoops`} render={() => <Whoops  pageName="returns" {...props} />} />
                <Route path={`${props.basePath}/OrderNotFound`} render={() => <OrderNotFound  pageName="returns" {...props} />} />
                <Route path={`${props.basePath}/EmailTemplateTest`} render={() => <EmailTemplateTest {...props} />} />
                <Route path={`${props.basePath}/OrderRestriction`} render={() => <OrderRestriction pageName="returns" {...props} />} />
            </Switch>
        </ThemeProvider >

    )
}
